import styled from '@emotion/styled';
import is from '@sindresorhus/is';

export const PrimaryButton = styled.button<{ readonly disabled?: boolean }>`
    cursor: ${(props) => (is.falsy(props.disabled) ? 'pointer' : 'not-allowed')};
    font-family: 'FT Regola Neue';
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1rem;
    display: flex;
    padding: 0.5rem 1rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.625rem;
    border: 1px solid #040f16;
    background: #040f16;
    width: 5.5rem;
    height: 2rem;
    color: white;
    opacity: ${(props) => (is.falsy(props.disabled) ? 1 : 0.4)};
`;
